// extracted by mini-css-extract-plugin
export default {"Error":"InputError_Error__i2bdV"};